import React from 'react';
import styled from 'styled-components';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  overflow-y: auto;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.5rem;
  color: #666;
  
  &:hover {
    color: #000;
  }
`;

const Button = styled.button`
  padding: 0.5rem 1rem;
  margin: 0.5rem;
  cursor: pointer;
  background-color: #2196F3;
  color: white;
  border: none;
  border-radius: 4px;
  transition: background-color 0.3s;

  &:hover {
    background-color: #1976D2;
  }
`;

const Input = styled.input`
  padding: 0.5rem;
  margin: 0.5rem;
  width: calc(100% - 2rem);
  border: 1px solid #ddd;
  border-radius: 4px;
  box-sizing: border-box;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1rem;
`;

const ResetButton = styled(Button)`
  background-color: #dc3545;
  
  &:hover {
    background-color: #c82333;
  }
`;

const ConfigModal = ({ isOpen, onClose, segments, onAddSegment, onRemoveSegment, onSegmentNameChange, onResetPrizes }) => {
    if (!isOpen) return null;

    return (
        <ModalOverlay onClick={onClose}>
            <ModalContent onClick={e => e.stopPropagation()}>
                <Header>
                    <h2>Cấu hình vòng quay</h2>
                    <CloseButton onClick={onClose}>&times;</CloseButton>
                </Header>

                <ButtonGroup>
                    <Button onClick={onAddSegment}>Thêm phần tử</Button>
                    <Button onClick={onRemoveSegment}>Xóa phần tử</Button>
                    <ResetButton onClick={onResetPrizes}>Reset phần thưởng</ResetButton>
                </ButtonGroup>

                <div>
                    {segments.map((segment, index) => (
                        <div key={index}>
                            <Input
                                type="text"
                                value={segment.option}
                                onChange={(e) => onSegmentNameChange(index, e.target.value)}
                                placeholder={`Phần tử ${index + 1}`}
                            />
                        </div>
                    ))}
                </div>
            </ModalContent>
        </ModalOverlay>
    );
};

export default ConfigModal; 